/// <reference path="../../../typings/hammerjs.d.ts" />
import { ElementRef, Injectable } from '@angular/core';
import * as HammerModule from 'hammerjs';
import { GestureAdapter } from './gesture-adapter.interface';
import { GestureEvent } from './gesture-event.interface';

const Hammer: any = (HammerModule as any).default ?? HammerModule;

@Injectable()
export class HammerGestureAdapter implements GestureAdapter {
  bindPan(
    element: ElementRef,
    handlers: {
      start?: (e: GestureEvent) => void;
      move?: (e: GestureEvent) => void;
      end?: (e: GestureEvent) => void;
    },
  ): () => void {
    const manager = new Hammer.Manager(element.nativeElement);

    const pan = new Hammer.Pan({
      direction: Hammer.DIRECTION_HORIZONTAL,
      threshold: 5,
    });

    manager.add(pan);

    const emit = (ev: any, isFinal = false) => {
      const event: GestureEvent = {
        deltaX: ev.deltaX,
        deltaY: ev.deltaY,
        velocityX: ev.velocityX,
        velocityY: ev.velocityY,
        direction:
          ev.direction === Hammer.DIRECTION_LEFT
            ? 'left'
            : ev.direction === Hammer.DIRECTION_RIGHT
            ? 'right'
            : ev.direction === Hammer.DIRECTION_UP
            ? 'up'
            : 'down',
        isFinal,
        originalEvent: ev.srcEvent,
      };

      return event;
    };

    if (handlers.start) {
      manager.on('panstart', (ev: any) => handlers.start!(emit(ev)));
    }

    if (handlers.move) {
      manager.on('panmove', (ev: any) => handlers.move!(emit(ev)));
    }

    if (handlers.end) {
      manager.on('panend pancancel', (ev: any) => handlers.end!(emit(ev, true)));
    }

    return () => {
      manager.destroy();
    };
  }
}
